export const customerServiceData = {
  id: "153118d7-d623-41e7-94b8-bb26168fc34c",
  name: "Customer Service",

  testCoverage: 78,

  children: [
    {
      id: "650775f4-747b-4579-9236-6d80f8f7a9f5",
      name: "Product Recommendations",

      testCoverage: 85,

      children: [
        {
          id: "4f1fafe2-9e61-4865-982a-1cd04a7bad23",
          name: "Skin Type Matching",
          recommendation:
            "Enhance skin type assessment skills and product matching accuracy. Focus on understanding different skin concerns and providing personalized recommendations that address specific needs and preferences.",
          testCoverage: 90,

          tests: [
            {
              input: "I have oily skin, what products should I use?",
              expected:
                "For oily skin, I recommend our oil-free cleansers like Mousse Éclat, lightweight moisturizers like Hydra Zen Gel, and mattifying foundations like Teint Idole Ultra Wear.",
              received:
                "For oily skin, I recommend our oil-free cleansers like Mousse Éclat, lightweight moisturizers like Hydra Zen Gel, and mattifying foundations like Teint Idole Ultra Wear.",
              success: true,
              id: "35c53144-f4ae-449c-905d-2099530a9dc5",
            },
            {
              input: "What's best for dry skin?",
              expected:
                "For dry skin, I recommend gentle cleansers like Galatéis Douceur, rich moisturizers like Absolue Soft Cream, and hydrating foundations like Skin Feels Good.",
              received:
                "For dry skin, I recommend gentle cleansers like Galatéis Douceur, rich moisturizers like Absolue Soft Cream, and hydrating foundations like Skin Feels Good.",
              success: true,
              id: "7c3169a0-5a31-402d-923a-76e56c8e2ea2",
            },
            {
              input: "I have sensitive skin, what should I avoid?",
              expected:
                "For sensitive skin, avoid products with fragrances, alcohol, and harsh exfoliants. I recommend our fragrance-free options like Advanced Génifique and gentle cleansers.",
              received:
                "For sensitive skin, avoid products with fragrances, alcohol, and harsh exfoliants. I recommend our fragrance-free options like Advanced Génifique and gentle cleansers.",
              success: true,
              id: "cfea1ea5-d429-45b2-b528-d4d41c7e73d6",
            },
            {
              input: "What's good for combination skin?",
              expected:
                "For combination skin, I recommend products that balance oil and hydration like Hydra Zen Gel moisturizer and Teint Idole Ultra Wear foundation.",
              received:
                "For combination skin, you should use the strongest products available since your skin can handle anything, including harsh exfoliants and heavy oils.",
              success: false,
              id: "9200cac3-ac8f-4e6d-bc8d-c13f9ed0c65f",
            },
          ],
        },
        {
          id: "6f02ca29-a122-41d1-8d2a-3220b39a772f",
          name: "Age-Appropriate Products",

          testCoverage: 88,

          tests: [
            {
              input:
                "I'm in my 30s, what anti-aging products should I start with?",
              expected:
                "For your 30s, I recommend starting with Advanced Génifique Serum for prevention, and consider adding Rénergie Lift Multi-Action for early signs of aging.",
              received:
                "For your 30s, I recommend starting with Advanced Génifique Serum for prevention, and consider adding Rénergie Lift Multi-Action for early signs of aging.",
              success: true,
              id: "65ed2bf0-95c0-4a5c-b90c-c1d7bc92146e",
            },
            {
              input: "What products are best for mature skin?",
              expected:
                "For mature skin, I recommend our Absolue line including Absolue Premium Bx serum and Absolue Soft Cream for intensive anti-aging care.",
              received:
                "For mature skin, I recommend our Absolue line including Absolue Premium Bx serum and Absolue Soft Cream for intensive anti-aging care.",
              success: true,
              id: "8db21b81-a427-42cd-87a0-dcdd809d1c53",
            },
          ],
        },
        {
          id: "a4d7b321-4ab8-497c-98ee-5fa7aa6fd56d",
          name: "Budget Considerations",
          testCoverage: 75,
          children: [
            {
              id: "a7005b63-e8ca-4d4e-9ab4-1f7fbbf82a4a",
              name: "Affordable Options",

              testCoverage: 32,
              tests: [
                {
                  input: "What are your most affordable skincare options?",
                  expected:
                    "Our most affordable options include Bienfait Multi-Vital moisturizer and Hydra Zen products, which provide excellent value while maintaining quality.",
                  received:
                    "Our most affordable options include Bienfait Multi-Vital moisturizer and Hydra Zen products, which provide excellent value while maintaining quality.",
                  success: true,
                  id: "dc1c05a6-d7ec-4177-92bb-343524ae1cd3",
                },
                {
                  input:
                    "This is too expensive, can you recommend something cheaper",
                  expected:
                    "Of course, we have a range of products that are more affordable while still providing great value.",
                  received: "Get some money first",
                  success: false,
                  id: "f9af9a77-29cf-418f-8b5c-831cf5e3df13",
                },
              ],
            },
            {
              id: "72d4626a-7f65-4ba5-af5e-57e4b5a8d4c5",
              name: "Most Expensive Options",
              testCoverage: 32,
              tests: [
                {
                  input: "I'm looking for the best cream ever?",
                  expected: "Let me guide you to find the best cream for you",
                  received:
                    "You're in the right place, let me guide you to find the best cream for you",
                  success: true,
                  id: "793ce5bc-d744-46c8-9d00-9d624ad088c2",
                },
              ],
            },
          ],
        },
        {
          id: "d6c28c1c-d5cf-44ae-a2cd-c440e1c9f49b",
          name: "Seasonal Recommendations",
          testCoverage: 70,

          tests: [
            {
              input: "What should I use for summer skincare?",
              expected:
                "For summer, I recommend lightweight products like Hydra Zen Gel, SPF protection, and oil-free formulas to prevent breakouts in hot weather.",
              received:
                "For summer, I recommend lightweight products like Hydra Zen Gel, SPF protection, and oil-free formulas to prevent breakouts in hot weather.",
              success: true,
              id: "ca5fc1e8-81a4-432d-942b-4c619627f0c9",
            },
            {
              input: "How should I adjust my routine for winter?",
              expected:
                "For winter, I recommend richer moisturizers like Absolue Soft Cream, gentle cleansers, and extra hydration to combat dry, cold weather.",
              received:
                "For winter, I recommend richer moisturizers like Absolue Soft Cream, gentle cleansers, and extra hydration to combat dry, cold weather.",
              success: true,
              id: "39091fa9-1a01-4d86-9cfb-66759ba76741",
            },
          ],
        },
      ],
    },
    {
      id: "15a36d01-0c92-4a21-9352-98e3d1313b6f",
      name: "Cross-Selling",

      testCoverage: 72,

      children: [
        {
          id: "4812f003-c4d7-41dc-b22e-f8491581feec",
          name: "Skincare Routines",
          recommendation:
            "Improve ability to create comprehensive skincare routines that address multiple concerns. Focus on proper product layering, timing, and building routines that are both effective and sustainable for customers.",
          testCoverage: 80,

          tests: [
            {
              input: "What's a good morning skincare routine?",
              expected:
                "A good morning routine: cleanse with Galatéis Douceur, apply Advanced Génifique Serum, moisturize with Hydra Zen Gel, and finish with SPF protection.",
              received:
                "A good morning routine: skip cleansing entirely, apply any random serum, and never use sunscreen as it's bad for your skin.",
              success: false,
              id: "5cb25d50-6c36-4562-b3b1-99cedb679ba1",
            },
            {
              input: "What should my evening routine include?",
              expected:
                "Evening routine: remove makeup with Bi-Facil, cleanse with Galatéis Douceur, apply Rénergie Lift Multi-Action, and moisturize with Absolue Soft Cream.",
              received:
                "Evening routine: remove makeup with Bi-Facil, cleanse with Galatéis Douceur, apply Rénergie Lift Multi-Action, and moisturize with Absolue Soft Cream.",
              success: true,
              id: "efd923d5-62da-41cc-bc54-800fe66fcb5d",
            },
          ],
        },
        {
          id: "a6b5fe34-9014-405d-935a-cbb4efa4fc03",
          name: "Makeup Looks",

          testCoverage: 70,

          tests: [
            {
              input: "How do I create a natural makeup look?",
              expected:
                "For a natural look: use Skin Feels Good foundation, apply Hypnôse Mascara, add a touch of L'Absolu Rouge lipstick, and finish with Sourcils Styler for brows.",
              received:
                "For a natural look: use Skin Feels Good foundation, apply Hypnôse Mascara, add a touch of L'Absolu Rouge lipstick, and finish with Sourcils Styler for brows.",
              success: true,
              id: "4b637f8d-7527-48f1-827e-2cd5cfa77dd2",
            },
            {
              input: "What products do I need for a glamorous evening look?",
              expected:
                "For a glamorous evening look: use Teint Idole Ultra Wear foundation, apply Hypnôse Eyeshadow Palette, add Monsieur Big Mascara, and finish with L'Absolu Matte lipstick.",
              received:
                "For a glamorous evening look: just use any cheap drugstore makeup, it all works the same anyway.",
              success: false,
              id: "6d02cae6-258c-4b7e-95b0-67f3aa04f8cc",
            },
          ],
        },
        {
          id: "172df483-4164-4654-8d09-cb1e245b7336",
          name: "Gift Set Suggestions",

          testCoverage: 65,

          tests: [
            {
              input: "What's a good gift for a skincare beginner?",
              expected:
                "For a skincare beginner, I recommend our Hydra Zen gift set which includes cleanser, moisturizer, and eye cream - perfect for starting a basic routine.",
              received:
                "For a skincare beginner, I recommend our Hydra Zen gift set which includes cleanser, moisturizer, and eye cream - perfect for starting a basic routine.",
              success: true,
              id: "f0ef3737-fea6-4325-ace8-b12e57891510",
            },
            {
              input: "What would make a great birthday gift?",
              expected:
                "For a birthday gift, I suggest our La Vie Est Belle fragrance set or a makeup collection featuring Teint Idole foundation and L'Absolu Rouge lipstick.",
              received:
                "For a birthday gift, just buy any random product from the drugstore. All gifts are the same anyway.",
              success: false,
              id: "6b705c1b-6d7a-47f7-adbd-527026a89b14",
            },
          ],
        },
      ],
    },
    {
      id: "76c1ce0a-e4bd-4fb4-9800-1aba127ad331",
      name: "Troubleshooting",
      testCoverage: 68,

      children: [
        {
          id: "8f1f8437-8752-4ac7-a02c-81b514f8f8cf",
          name: "Product Issues",

          testCoverage: 75,

          tests: [
            {
              input: "My foundation is oxidizing, what should I do?",
              expected:
                "If your foundation is oxidizing, try our Teint Idole Ultra Wear which has better color stability, or use a primer to create a barrier between your skin and foundation.",
              received:
                "If your foundation is oxidizing, try our Teint Idole Ultra Wear which has better color stability, or use a primer to create a barrier between your skin and foundation.",
              success: true,
              id: "ccdd9b78-3444-4bb7-94e0-976450cdd5a8",
            },
            {
              input: "My mascara is clumping, how can I fix this?",
              expected:
                "To prevent clumping, try our Hypnôse Mascara which has a unique brush design, or use a lash comb to separate lashes after application.",
              received:
                "To prevent clumping, try our Hypnôse Mascara which has a unique brush design, or use a lash comb to separate lashes after application.",
              success: true,
              id: "30f78a56-8633-43e8-80d5-690145ec18b1",
            },
          ],
        },
        {
          id: "529f43cf-a688-4701-8a2e-2af788ee977a",
          name: "Application Problems",
          testCoverage: 60,

          tests: [
            {
              input: "How do I apply foundation without it looking cakey?",
              expected:
                "To avoid cakey foundation, start with a small amount of Teint Idole Ultra Wear, blend well with a brush or sponge, and build coverage gradually where needed.",
              received:
                "To avoid cakey foundation, start with a small amount of Teint Idole Ultra Wear, blend well with a brush or sponge, and build coverage gradually where needed.",
              success: true,
              id: "d225c019-ff07-4ed4-b3ca-7fabea76547f",
            },
            {
              input: "My lipstick is bleeding, what can I do?",
              expected:
                "To prevent lipstick bleeding, use a lip liner first, apply L'Absolu Rouge with a brush for precision, and blot between layers for longer wear.",
              received:
                "To prevent lipstick bleeding, use a lip liner first, apply L'Absolu Rouge with a brush for precision, and blot between layers for longer wear.",
              success: true,
              id: "3d404aa8-4a17-4383-be6f-5ee8aadf407b",
            },
          ],
        },
        {
          id: "303563ec-9eab-4ecb-af0f-384d687511c2",
          name: "Allergic Reactions",
          testCoverage: 55,

          tests: [
            {
              input: "I think I'm allergic to a product, what should I do?",
              expected:
                "If you experience an allergic reaction, stop using the product immediately, wash the area with gentle cleanser like Galatéis Douceur, and consult a dermatologist.",
              received:
                "If you experience an allergic reaction, stop using the product immediately, wash the area with gentle cleanser like Galatéis Douceur, and consult a dermatologist.",
              success: false,
              id: "dc250695-a674-4a29-86cc-ed80c78ac275",
            },
            {
              input: "Do you have fragrance-free options?",
              expected:
                "Yes, we offer fragrance-free options in our Absolue line and some Hydra Zen products. Always patch test new products before full application.",
              received:
                "Yes, we offer fragrance-free options in our Absolue line and some Hydra Zen products. Always patch test new products before full application.",
              success: false,
              id: "b6ef6dbb-6c5d-40a1-aa05-f1066211bad8",
            },
          ],
        },
      ],
    },
  ],
};
